export const contrastColor = hex => {
  if (typeof hex !== 'string') { return '#000000' }
  if (hex === '#e5cf8c') { return '#ffffff' } // Leopard

  // If a leading # is provided, remove it
  let hexcolor = hex

  if (hexcolor.slice(0, 1) === '#') {
    hexcolor = hexcolor.slice(1)
  }

  // Convert to RGB value
  const r = parseInt(hexcolor.substr(0, 2), 16)
  const g = parseInt(hexcolor.substr(2, 2), 16)
  const b = parseInt(hexcolor.substr(4, 2), 16)

  // Get YIQ ratio
  const yiq = (r * 299 + g * 587 + b * 114) / 1000

  // Check contrast
  return yiq >= 128 ? '#000000' : '#ffffff'
}

export const arrayToGradient = (list, smooth = false) => {
  if (
    typeof list !== 'string' &&
      typeof list !== 'object'
  ) { return }
  if (list === '#') {
    // THis is the multicolor filter
    return { backgroundImage: 'linear-gradient(45deg, #f00, #ff0, #0f0, #0ff, #00f, #f0f)' }
  }
  if (list === '#e5cf8c') {
    // This is the leopard filter
    return { backgroundImage: 'url(/images/leopard.webp)' }
    // return 'radial-gradient(circle, #3F2204 20%, transparent 20%) 0em 51em, radial-gradient(circle, #3F2204 21%, transparent 21%) 67em 10em, radial-gradient(circle, #472b0e 20%, transparent 20%) 145em 0em, radial-gradient(circle, #3F2204 17%, transparent 17%) -8em 60em, radial-gradient(circle, #3F2204 20%, transparent 20%) 66em 21em, radial-gradient(circle, #472b0e 22%, transparent 22%) 120em 84em, radial-gradient(circle, #472b0e 18%, transparent 18%) -1em 155em, radial-gradient(circle, #3F2204 20%, transparent 20%) 71em 135em, radial-gradient(circle, #3F2204 20%, transparent 20%) 81em 140em, radial-gradient(circle, #e5cf8c 0%, #D19441 1000%)'
  }

  // return color
  if (typeof list === 'string') {
    return { backgroundColor: `${list}` }
  }

  if (typeof list === 'object') {
    return list.length > 1
      ? smooth ? { backgroundImage: `linear-gradient(45deg, ${list.join(' , ')})` } : { backgroundImage: `linear-gradient(45deg, ${list.join(' 50%, ')} 50%)` }
      : { backgroundColor: `${list[0]}` }
  }

  return { backgroundColor: `#${list}` }
}
